import axios from "axios";
import { useCallback, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";

const API = "/api";
// Mesmo ritmo do acompanhamento da coluna Pronto: cada tick chama a UP por pedido.
const INTERVALO_MS = 15000;
const EM_ENTREGA = ["em_rota", "na_bag"];

const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

const mensagemDoErro = (e) => {
  const d = e?.response?.data?.detail;
  return (typeof d === "object" ? d?.message : d) || "Não foi possível confirmar o recebimento. Tente de novo.";
};

/**
 * Pedidos em entrega pela UP Entrega que esperam a loja confirmar o dinheiro.
 * Só lê o estado de pedido em rota (GET /entregaai/orders-status) e só quando a
 * integração está ligada. `confirmar` chama POST /entregaai/orders/{id}/confirm-cash.
 */
export function useDinheiroUP({ ativo, pedidos }) {
  const [estados, setEstados] = useState({});
  const [confirmando, setConfirmando] = useState(null);

  const emEntrega = useMemo(
    () => (pedidos || []).filter((p) => EM_ENTREGA.includes(p.status) && p.tipo_entrega !== "pickup"),
    [pedidos],
  );
  const chave = emEntrega.map((p) => p.id).join(",");

  useEffect(() => {
    if (!ativo || !chave) {
      setEstados({});
      return undefined;
    }
    let vivo = true;
    const ler = async () => {
      try {
        const { data } = await axios.get(`${API}/entregaai/orders-status?pedido_ids=${chave}`, auth());
        if (vivo) setEstados(data || {});
      } catch {
        // Mantém a última leitura.
      }
    };
    ler();
    const timer = setInterval(ler, INTERVALO_MS);
    return () => { vivo = false; clearInterval(timer); };
  }, [ativo, chave]);

  const aguardando = useMemo(
    () => emEntrega
      .map((pedido) => ({ pedido, estado: estados[pedido.id] }))
      .filter(({ estado }) => estado && estado.entregaai_cash_required && !estado.entregaai_cash_received),
    [emEntrega, estados],
  );

  const confirmar = useCallback(async (pedidoId) => {
    setConfirmando(pedidoId);
    try {
      await axios.post(`${API}/entregaai/orders/${pedidoId}/confirm-cash`, {}, auth());
      setEstados((atual) => ({ ...atual, [pedidoId]: { ...atual[pedidoId], entregaai_cash_received: true } }));
      toast.success("Recebimento confirmado. O entregador já pode finalizar.");
    } catch (e) {
      toast.error(mensagemDoErro(e));
    } finally {
      setConfirmando(null);
    }
  }, []);

  return { aguardando, confirmando, confirmar };
}
